import { render } from "./ColoredEntryList.vue?vue&type=template&id=63b0ca59&scoped=true&ts=true"
import script from "./ColoredEntryList.vue?vue&type=script&lang=ts"
export * from "./ColoredEntryList.vue?vue&type=script&lang=ts"

import "./ColoredEntryList.vue?vue&type=style&index=0&id=63b0ca59&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63b0ca59"]])

export default __exports__